export const formatNumberWithTwoFractionDigits = (value: number|undefined, locale: string, missingValuePlaceholder: string): string => {
  if (value === undefined) {
    return missingValuePlaceholder;
  } else {
    const formatter = Intl.NumberFormat(locale, { minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: false });
    return formatter.format(value);
  }
};